import React from 'react'
import styles from './Footer.module.css'

export default function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className={styles.footer}>
            <h1>お電話でのお問い合わせはこちら</h1>
            <a className={styles.footerTel} href='tel:0120-313-704'>
                <img
                    className={styles.footerTelImagePc}
                    src='/pages/business/hotelslabo/footer_tel_image_pc.png'
                    alt='0120-313-704'
                />
                <img
                    className={styles.footerTelImageSp}
                    src='/pages/business/hotelslabo/footer_tel_image_sp.png'
                    alt='0120-313-704'
                />
            </a>
            <p>
                資料請求以外のお問い合わせは、
                <span className={styles.br}>renraku@coulega.co.jp</span>
            </p>

            <small>
                厚生労働大臣許可番号有料職業紹介事業許可番号13-ユ-308506
                <br />
                Copyright &copy; {currentYear} hotelsLabo by cuolega All rights
                reserved.
            </small>
            <div>
                <a href='https://cuolega.co.jp/privacy/'>
                    プライバシーポリシー
                </a>
                <a href='https://cuolega.co.jp/terms/'>利用規約</a>
                <a href='https://cuolega.co.jp/profile/'>会社概要</a>
            </div>
        </footer>
    )
}
